import type { PhoneLoginDto as SdkPhoneLoginDto, PhoneSignupDto } from '@nomiss/sdk';
import {
  ApiRequestError,
  executeSdkRawRequest,
} from './api-request.util';
import { authenticationApi } from './sdk-client';

export type AuthTokenPair = {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
};

export type PhoneLoginDto = SdkPhoneLoginDto;

export class PhoneAuthError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'PhoneAuthError');
  }
}

export async function phoneSignup(dto: PhoneSignupDto): Promise<AuthTokenPair> {
  return executeSdkRawRequest({
    request: () =>
      authenticationApi.authControllerPhoneSignupV1Raw({
        phoneSignupDto: dto,
      }),
    fallback: 'Phone signup failed',
    ErrorClass: PhoneAuthError,
  });
}

export async function phoneLogin(dto: PhoneLoginDto): Promise<AuthTokenPair> {
  return executeSdkRawRequest({
    request: () =>
      authenticationApi.authControllerPhoneLoginV1Raw({
        phoneLoginDto: dto,
      }),
    fallback: 'Phone login failed',
    ErrorClass: PhoneAuthError,
  });
}

/** Backend test mode token when `FIREBASE_AUTH_SKIP_VERIFY=true`. */
export function buildTestFirebaseToken(
  phoneE164: string,
  uid = `nomiss-${Date.now()}`,
): string {
  return `test:${phoneE164}:${uid}`;
}

export function isPhoneSignupStubEnabled(): boolean {
  if (process.env.EXPO_PUBLIC_APP_ENV === 'production') {
    return false;
  }
  return process.env.EXPO_PUBLIC_PHONE_SIGNUP_STUB === 'true';
}
